var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.864,
    height: 24.92,
    viewBox: "0 0 27.864 24.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45",
    transform: "translate(0.563 0.557)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85338",
    "data-name": "Path 85338",
    d: "M26.34,10.021C20.364,1.842,7.5,4.521,5.109,14.184l-1.435-2.75a.889.889,0,1,0-1.573.831L4.864,17.5a.889.889,0,0,0,.982.444,1.883,1.883,0,0,0,.222-.08l5.26-2.754a.9.9,0,0,0-.853-1.577L6.655,15.552a10.174,10.174,0,1,1,4.038,9.73A.889.889,0,1,0,9.64,26.712a11.826,11.826,0,0,0,7.068,2.319c9.676.084,15.429-11.276,9.631-19.01Z",
    transform: "translate(-1.998 -5.169)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.0dbb377157add92ea9498b7099fb1604.svg";
export { ForwardRef as ReactComponent };